import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { usePersistStore, useStore } from "../../store";
import { useState } from "react";
import { UserService } from "../../services";
import Avatar from "../Avatar";
import Confirm from "../Confirm";
import Logo from "../Logo";
import NotificationsPopup from "../NotificationsPopup";
import Search from "../Search";
import ThemeToggle from "../ThemeToggle";

const Header = () => {
  const navigate = useNavigate();
  const { resetFilters } = useStore((s: any) => s);
  const { logout, user, token } = usePersistStore((s: any) => s);
  const [showConfirm, setShowConfirm] = useState(false);

  let authenticate = user && token;

  const handleLogout = async () => {
    try {
      if (token) await UserService.logoutAll(token);
    } catch (e) {}
    logout();
    window.location.href = "/login";
  };

  const location = useLocation();

  const isSupportPage = [
    "/help-and-support",
    "/terms-and-conditions",
  ].includes(location.pathname);

  return (
    <>
      <Container className="px-md-0 px-3">
        <Navbar expand="lg" className="position-relative px-0">
          <Navbar.Brand>
            <Link to="/" onClick={resetFilters}>
              <Logo width={72} height={72} className="headerLogo" />
            </Link>
          </Navbar.Brand>
          <div className="headerSearch">
            <Search onClick={() => navigate("/search")} />
          </div>
          {authenticate ? (
            <div className="d-flex align-items-center gap-3 profileHolder">
              <NotificationsPopup />
              <div className="headerAvatarMenu">
                <button
                  type="button"
                  className="headerAvatarMenu__trigger"
                  aria-label="Open account menu"
                >
                  <Avatar
                    src={user?.fileUrl}
                    name={user?.name}
                    className="headerAvatar"
                    style={{
                      borderRadius: "50%",
                      border: "1px solid var(--border-divider)",
                      objectFit: "cover",
                      objectPosition: "center center",
                    }}
                  />
                </button>
                <div className="headerAvatarMenu__menu" role="menu">
                  <Link
                    to="/dashboard"
                    className="headerAvatarMenu__item"
                    role="menuitem"
                  >
                    <i className="bi bi-grid-fill" aria-hidden="true" />
                    <span>Dashboard</span>
                  </Link>
                  <Link
                    to="/dashboard/profile"
                    className="headerAvatarMenu__item"
                    role="menuitem"
                  >
                    <i className="bi bi-person" aria-hidden="true" />
                    <span>Profile</span>
                  </Link>
                  <div className="headerAvatarMenu__themeRow" role="none">
                    <span className="headerAvatarMenu__themeLabel">Theme</span>
                    <ThemeToggle />
                  </div>
                  <button
                    type="button"
                    className="headerAvatarMenu__item headerAvatarMenu__item--danger"
                    role="menuitem"
                    onClick={() => setShowConfirm(true)}
                  >
                    <i className="bi bi-box-arrow-right" aria-hidden="true" />
                    <span>Logout</span>
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="d-flex gap-3 align-items-center btnsHolder">
              {/* Single hamburger menu across all screen sizes */}
              <div className="headerGuestMenu">
                <button
                  type="button"
                  className="headerGuestMenu__trigger"
                  aria-label="Open menu"
                >
                  <i className="bi bi-list" aria-hidden="true" />
                </button>
                <div className="headerGuestMenu__menu" role="menu">
                  <Link
                    to="/login"
                    className="headerAvatarMenu__item"
                    role="menuitem"
                  >
                    <i className="bi bi-box-arrow-in-right" aria-hidden="true" />
                    <span>Login</span>
                  </Link>
                  <Link
                    to="/register"
                    className="headerAvatarMenu__item"
                    role="menuitem"
                  >
                    <i className="bi bi-person-plus" aria-hidden="true" />
                    <span>Register</span>
                  </Link>
                  {!isSupportPage && (
                    <button
                      type="button"
                      className="headerAvatarMenu__item"
                      role="menuitem"
                      onClick={() => navigate("/help-and-support")}
                    >
                      <i className="bi bi-headset" aria-hidden="true" />
                      <span>Support</span>
                    </button>
                  )}
                  <div className="headerAvatarMenu__themeRow" role="none">
                    <span className="headerAvatarMenu__themeLabel">Theme</span>
                    <ThemeToggle />
                  </div>
                </div>
              </div>
            </div>
          )}
        </Navbar>
      </Container>
      <Confirm
        show={showConfirm}
        onNo={() => setShowConfirm(false)}
        onYes={handleLogout}
        title="Log out of Boll-e™?"
        body="You'll need to sign in again to bid, list, or message sellers."
        closeButtonText="Stay signed in"
        confirmButtonText="Log out"
        variant="primary"
        iconClass="bi-box-arrow-right"
      />
    </>
  );
};

export default Header;
